<template>
  <v-container
    fluid
    class="sign-form"
  >
    <v-row>
      <v-col
        sm="12"
        md="4"
        cols="12"
      >
        <v-card
          align="center"
          class="signup-card"
        >
          <a
            href="/"
            title="Britecheck.com"
          >
            <img
              class="logo-img"
              src="@/assets/images/logo-britecheck.svg"
              width="220"
              height="36"
              alt="Britecheck"
            >
          </a>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="login-main">
      <v-col
        sm="12"
        md="12"
        cols="12"
      >
        <v-row justify="center">
          <v-col
            sm="12"
            md="12"
            cols="12"
            style="padding: unset"
          >
            <v-card-subtitle align="center">
              <h1 class="login-subtitle">
                Sign Up
              </h1>
            </v-card-subtitle>
            <v-card-text
              align="center"
              class="login-welcome"
            >
              Already have an account?
              <a
                depressed
                class="link-sign"
                @click="$router.push({ name: 'Login' })"
              >Sign In Now</a>
            </v-card-text>
          </v-col>
        </v-row>
        <v-row
          justify="center"
          class="signup-container"
        >
          <v-col
            sm="12"
            md="5"
            lg="4"
            cols="12"
          >
            <v-card
              align="center"
              class="signup-card"
            >
              <RegisterForm class="signup-form" />
            </v-card>
          </v-col>
          <v-col
            sm="12"
            md="5"
            lg="4"
            cols="12"
          >
            <v-card class="signup-card">
              <div class="social_block_sign">
                <div
                  class="social-button"
                  style="display: none !important;"
                >
                  <v-btn class="button_login_new fb_button_login_new">
                    <div class="buttonIcon">
                      <div class="buttonSvgImage" />
                    </div>
                    <span class="button_login_new__text">Sign Up with Facebook</span>
                  </v-btn>
                </div>
                <div class="social-button">
                  <a
                    href="/auth/google"
                    class="button_login_new google_button_login_new"
                  >
                    <div class="buttonIcon">
                      <div class="buttonSvgImage" />
                    </div>
                    <span class="button_login_new__text">Sign Up with Google</span>
                  </a>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col
            sm="12"
            md="12"
            cols="12"
            style="padding: unset"
          >
            <v-card
              align="center"
              class="signup-card"
            >
              <v-card-text class="text-center terms-policy">
                By signing up you agree to our <span class="text-nowrap"><a
                  class="subtitle-2"
                  href="privacy-policy.html"
                >Privacy policy</a> & <a
                  class="subtitle-2"
                  href="terms-of-use.html"
                >Term of use</a>.</span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RegisterForm from '@/components/user/RegisterForm'
export default {
  name: 'Register',
  components: {
    RegisterForm
  },
  metaInfo: {
    title: 'Sign Up for Easy Inventory Management Today',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'Join now to simplify inventory tracking and boost your small business. Get started with our intuitive inventory management software'
      }
    ]
  }
}
</script>

<style lang="css">
.body--light {
  background: whitesmoke;
}
.sign-form {
  background-color: #f5f5f5 !important;
  min-height: 100vh;
}
.link-sign {
  color: #7671bd;
  transition: 0.3s;
}
.link-sign:hover {
  cursor: pointer;
  text-decoration: underline;
  transition: 0.3s;
}
.signup-img .v-image__image--cover {
  background-size: 100% !important;
}
.subtitle-2 {
  text-decoration: none;
}
.sign-form {
  background-color: #f5f5f5 !important;
}
.sign-form .theme--light.v-card {
  background-color: #f5f5f5 !important;
}
.signup-card {
  height: 100%;
  margin: unset;
  border-radius: unset !important;
  background-color: #f5f5f5 !important;
  box-shadow: none !important;
}
@media screen and (max-width: 768px) {
  .signup-card {
    height: 100%;
    margin: unset;
    border-radius: unset !important;
    background-color: #f5f5f5 !important;
    box-shadow: none !important;;
  }
  .signup-img {
    display: none;
  }
}
</style>
